var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBtnYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9248 15.0928L14.3312 13.416C14.0176 13.2704 13.76 13.4336 13.76 13.7808V16.9392C13.76 17.2864 14.0176 17.4496 14.3312 17.304L17.9232 15.6272C18.2384 15.48 18.2384 15.24 17.9248 15.0928ZM15.36 0C6.8768 0 0 6.8768 0 15.36C0 23.8432 6.8768 30.72 15.36 30.72C23.8432 30.72 30.72 23.8432 30.72 15.36C30.72 6.8768 23.8432 0 15.36 0ZM15.36 21.6C7.4976 21.6 7.36 20.8912 7.36 15.36C7.36 9.8288 7.4976 9.12 15.36 9.12C23.2224 9.12 23.36 9.8288 23.36 15.36C23.36 20.8912 23.2224 21.6 15.36 21.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtnYoutube);
export default __webpack_public_path__ + "static/media/ic_btn_youtube.f3aa53a7f3fee58b6634deea5f784020.svg";
export { ForwardRef as ReactComponent };